import { render, staticRenderFns } from "./contractConfigList.vue?vue&type=template&id=2d9ed686&scoped=true"
import script from "./contractConfigList.vue?vue&type=script&lang=js"
export * from "./contractConfigList.vue?vue&type=script&lang=js"
import style0 from "./contractConfigList.vue?vue&type=style&index=0&id=2d9ed686&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9ed686",
  null
  
)

export default component.exports